export const copyObject = (objectToCopy) => {
  return JSON.parse(JSON.stringify(objectToCopy));
};
